import * as z from 'zod';
/**
 * A language a child understands, and a language a video can be heard in.
 *
 * Not the same thing as `Locale`. A locale is one of the two languages this
 * product's own interface is written in; a language is any the family speaks.
 * Which videos exist dubbed into German or Arabic has nothing to do with which
 * languages our buttons are translated into, so the two lists are kept apart.
 *
 * ISO 639-1 codes. Regional variants are deliberately absent: YouTube labels a
 * track `en-US` or `zh-Hans`, and a parent choosing "English" means all of them.
 */
export const languageSchema = z.enum([
    'tr',
    'en',
    'de',
    'fr',
    'es',
    'it',
    'pt',
    'nl',
    'ru',
    'ar',
    'ja',
    'ko',
    'zh',
]);
export const LANGUAGES = languageSchema.options;
/** How many languages a child may be practising at once. */
export const MAX_FOREIGN_LANGUAGES = 5;
/**
 * The language a child's profile starts with.
 *
 * Taken from the locale the profile was created with — every locale is also a
 * language — so a family that never opens the language settings still gets
 * videos in the language their child's interface speaks.
 */
export const languageForLocale = (locale) => locale;
//# sourceMappingURL=language.js.map